export const CHECK_NOTIFICATIONS_INTERVAL = 60 * 1000;
export const COUNTRY_NAME = "Россия";
export const CHECK_GEOLOCATION_INTERVAL = 1800000;
export const CHECK_GEOLOCATION_MAXIMUM_AGE = 60000;
export const CHECK_GEOLOCATION_TIMEOUT = 10000;
export const MATCH_USER_KEY = "match_current_user";
export const MATCH_USERS_KEY = "match_users";
export const MATCH_USERS_BACKUP_KEY = "match_users_backup";
export const MATCH_INDEX_KEY = "match_current_index";
export const MATCH_VISITED_ID_KEY = "match_last_visited_id";
export const FROM_MATCH_FLAG = "from_match_component";
export const CURRENT_INDEX_KEY = "match_current_index";
export const FORCE_RESTORE_FLAG = "match_force_restore";
